import play_white from './ic_120/play_ic.png';
import play_dark from './ic_120/play_ic_dark.png';
import pause_white from './ic_120/pause_ic.png';
import pause_dark from './ic_120/pause_ic_dark.png';
import placeholder from './placeholder.png';
import family_ic from './icon/family_ic.png';
import village_ic from './icon/village_ic.jpg';
import addBookmark from './addBookmark.png';
import AppStore from './apple_btn.png';
import PlayStore from './google_btn.png';
import familyIc from './icon/family_place_ic.png';
import ShildIc from './icon/family_security_ic.png';
import connectionErrorIc from './connectionErrorIc.png';
import lock_ic_dark from './icon/lock_ic_dark.png';
import not_connect_graphic from './not_connect_graphic.png';
import forgot_ic from './icon/forgot_ic.png'
import calendar_ic from './ic_120/calendar_ic.png';
import riddle_ic from './daily-riddle-icon.png'
import wave_ic from './ic_120/audio_white_icn.png';
import dv_app_logo from './dv_app_logo.png';
import ev_app_logo from './ev_app_logo.png';

import icon_email from './setting_icons/icon_email.png';
import icon_Language from './setting_icons/icon_Language.png';
import icon_Logout from './setting_icons/icon_Logout.png';
import icon_PrivacyPolicy from './setting_icons/icon_PrivacyPolicy.png';
import icon_Support from './setting_icons/icon_Support.png';
import icon_TEL from './setting_icons/icon_TEL.png';
import icon_UseTerms from './setting_icons/icon_UseTerms.png';
import icon_WE from './setting_icons/icon_WE.png';

import error_ic from './icon/Error.png';
import success_ic from './icon/check_ic.png';
import AmericaU_cert from './AmericaU_cert.jpg';

export {
  dv_app_logo,
  ev_app_logo,
  play_white,
  play_dark,
  pause_white,
  pause_dark,
  placeholder,
  family_ic,
  village_ic,
  addBookmark,
  AppStore,
  PlayStore,
  familyIc,
  ShildIc,
  connectionErrorIc,
  lock_ic_dark,
  not_connect_graphic,
  forgot_ic,
  calendar_ic,
  riddle_ic,
  wave_ic,
  icon_email,
  icon_Language,
  icon_Logout,
  icon_PrivacyPolicy,
  icon_Support,
  icon_TEL,
  icon_UseTerms,
  icon_WE,
  error_ic,
  success_ic,
  AmericaU_cert
}
